import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'

import { Route } from 'react-router-dom'

import Button from '@material-ui/core/Button';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import JitsuLoader from '../JitsuLoader/';


import firebase from '../../firebase'
import { emailSignUp, initFacebookSignUp } from './actions'

class SignUpComponet extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: ""
    }
  }

  signUpWithEmail = () => {

    var {email, password} = this.state;

    var {locationUtil: {params}} = this.props;

    this.setState({
      showLoader: true
    })

    this.props.emailSignUp(email, password, params.chatToken);

  }

  pressEnter = (event) => {

    if (event.keyCode == 13) {

      var {email, password} = this.state;

      var {locationUtil: {params}} = this.props;

      this.props.emailSignUp(email, password, params.chatToken);
    }

  }

  signUpWithFaceBook = () => {

    this.props.initFacebookSignUp()

  }

  componentDidMount = () => {

  }

  render() {

    return (
      <div style={ { backgroundColor: "black" } } className="h-100 d-flex flex-column align-items-center scroll-y">
        <br/>
        <br/>
        <h1 style={ { fontSize: "5vh", color: "white", fontFamily: "'Gloria Hallelujah', cursive" } }>join jitsu chat today !</h1>
        <br/>
        <div>
          <Card>
            <CardContent>
              <TextField value={ this.state.email } onChange={ event => this.setState({
                                                                 email: event.target.value
                                                               }) } InputLabelProps={ { shrink: true, } } placeholder="Email" fullWidth margin="normal" />
              <TextField onChange={ event => this.setState({
                                      password: event.target.value
                                    }) } onKeyUp={ (event) => this.pressEnter(event) } value={ this.state.password } type="password" InputLabelProps={ { shrink: true, } } placeholder="Password"
                fullWidth margin="normal" />
              <Button onClick={ () => this.signUpWithEmail() } variant="contained" color="primary">
                Sign Up
              </Button>
              <br/>
              <div style={ { color: 'white' } } className="d-flex flex-column align-items-center w-100">
                <br/>
                <Divider className="w-100" />
                <br/>
                <br/>
                <Button onClick={ () => window.location.hash = "login" } color="primary">
                  Login Screen
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
        <br/>
        <h1 style={ { fontSize: "5vh", color: "white", fontFamily: " 'Gloria Hallelujah', cursive" } }>and jitsu chat away !</h1>
        <br/>
        { this.state.showLoader && <JitsuLoader/> }
      </div>

      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  locationUtil: state.locationUtil
})

const SignUp = connect(mapStateToProps, {
  emailSignUp,
  initFacebookSignUp
})(SignUpComponet)

export default SignUp


// WEBPACK FOOTER //
// ./src/Components/SignUp/index.js